import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { profileService } from 'domain/profile/api/profileService';
import { UserProfile } from 'types/userProfile';

function useGetProfileInfo(): UseQueryResult<UserProfile> {
  return useQuery({
    queryKey: ['profileInfo'],
    queryFn: profileService.getProfileInfo,
  });
}

export default useGetProfileInfo;
